"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const button_1 = tslib_1.__importDefault(require("antd/es/button"));
function Button(_a) {
    var { children, className = '' } = _a, allProps = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement(button_1.default, Object.assign({ className: `clp-btn ${className}` }, allProps), children));
}
exports.Button = Button;
//# sourceMappingURL=Button.js.map